// TUS resumable-upload helper for Path A master uploads (Stage 3d).
//
// Wraps tus-js-client against Supabase Storage's native resumable
// endpoint. Supabase REQUIRES a 6 MiB chunk size — tus-js-client
// otherwise sends the whole file in one request, which Supabase
// rejects. The caller supplies a short-lived Supabase-compatible JWT
// minted by POST /api/masters/upload-token.
import * as tus from 'tus-js-client';

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const ANON_KEY     = process.env.REACT_APP_SUPABASE_ANON_KEY;
const CHUNK_SIZE   = 6 * 1024 * 1024;   // 6 MiB — Supabase TUS hard requirement

// Resolves on a completed upload, rejects on error. onProgress(pct)
// fires with 0–100 as chunks land.
export function tusUpload({ file, token, bucket, objectName, contentType, onProgress }) {
  return new Promise((resolve, reject) => {
    const upload = new tus.Upload(file, {
      endpoint: `${SUPABASE_URL}/storage/v1/upload/resumable`,
      chunkSize: CHUNK_SIZE,
      // Gate 4 — auto-resume transient network drops. tus-js-client
      // retries the failed request (resuming from the cached upload
      // URL) at these backoffs; onError fires only once all are spent.
      retryDelays: [0, 3000, 5000, 10000, 20000],
      removeFingerprintOnSuccess: true,
      headers: {
        authorization: `Bearer ${token}`,
        apikey: ANON_KEY,
        'x-upsert': 'true',
      },
      metadata: {
        bucketName: bucket,
        objectName,
        contentType: contentType || 'application/octet-stream',
      },
      onError: (err) => reject(err),
      onProgress: (sent, total) => {
        if (onProgress && total) onProgress(Math.round((sent / total) * 100));
      },
      onSuccess: () => resolve(),
    });
    upload.start();
  });
}
